import { logout } from '../../Redux/Auth/authActions'; 
import * as ActionTypes from '../Constants/actionTypes';

const errorHandlingMiddleware = store => next => action => {
    if (action.type === ActionTypes.LOGIN_FAILURE && action.payload === 'Token is invalid or expired') {
        store.dispatch(logout());
    }
    return next(action);
};

export default errorHandlingMiddleware;
